import gql from 'graphql-tag';
import { PROJECT_BANK_ATTACHMENT_SELECTION } from './projectBankAttachmentSelection';

/**
 * Data of the block project-bank-employment-income ("Einkommen / Lohn / Gehalt", tab Bank): the bank attachments of its types. Read through
 * `Project.blocks.bankEmploymentIncome`, which checks the block's read permission.
 */
export const PROJECT_BANK_EMPLOYMENT_INCOME_FIELDS = gql`
  fragment projectBankEmploymentIncomeFields on ProjectBankEmploymentIncomeBlock {
    id
    number
    bank {
      ${PROJECT_BANK_ATTACHMENT_SELECTION}
    }
  }
`;
